import { Skeleton, useValidationResultDialog } from '@nest/uikit-react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';

export default function OutboundWavelessListPage() {
	const documentTypeId = useNumberParam('documentTypeId');
	const queueId = useNumberParam('queueId');
	const client = useTerminalClient();
	const navigate = useNavigate();

	const documentType = useQuery({
		queryKey: ['outbound-document-type', documentTypeId],
		queryFn: () => client.outboundDeliveryOrderDocumentTypes.getById.execute({ id: documentTypeId! }),
		enabled: !!documentTypeId
	});

	const { data: suggestions, error } = useQuery({
		queryKey: ['waveless-suggest-pick-locations', documentTypeId],
		queryFn: () =>
			client.outboundDeliveryOrders.outboundWavelessSuggestPickingNextPickLocationsQuery.execute({
				documentTypeId: documentTypeId!,
				outboundQueueId: queueId
			}),
		enabled: !!documentTypeId
	});

	const assignMutation = useMutation({
		mutationFn: (locationId: number) =>
			client.outboundDeliveryOrders.outboundWavelessAssignNextPickToPickerMutation.execute({
				documentTypeId: documentTypeId!,
				locationId,
				outboundQueueId: queueId
			}),
		onSuccess: () => navigate(`/outbound/${documentTypeId}/waveless/${queueId}/process`)
	});

	useValidationResultDialog([error, assignMutation.error]);

	return (
		<TerminalScreen showBackButton topBar={documentType.data?.name}>
			<div className="p-2 flex flex-col gap-4 flex-1 overflow-auto h-full">
				{suggestions ? (
					suggestions.length === 0 ? (
						<div className="p-6 text-center text-muted-foreground">Žádné návrhy</div>
					) : (
						<div className="grid grid-cols-1 gap-2">
							{suggestions.map(suggestion => (
								<button
									key={`${suggestion.suggestedLocation.stockItem.id}-${suggestion.suggestedLocation.id}`}
									className="w-full border rounded p-2 text-left hover:bg-muted/50 flex flex-col gap-1"
									onClick={() => assignMutation.mutate(suggestion.suggestedLocation.id)}
								>
									<div className="font-semibold">{suggestion.suggestedLocation.stockItem.item.name}</div>
									<div className="flex gap-2">
										<span className="bg-muted text-muted-foreground px-2 py-1 rounded-md">{suggestion.suggestedLocation.storageLocation.name}</span>
										<div className="flex-1"></div>
										<span className="bg-muted text-muted-foreground px-2 py-1 rounded-md">Množství: {suggestion.quantityToPick}</span>
									</div>
									{(suggestion.processingUsers?.length ?? 0) > 0 && (
										<span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-md">Zpracovává: {suggestion.processingUsers!.join(', ')}</span>
									)}
								</button>
							))}
						</div>
					)
				) : (
					<div className="space-y-2">
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</div>
				)}
			</div>
		</TerminalScreen>
	);
}
